


import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	NavigationWrapper,
	PickerHOC,
	TargetsWrapper,
	TestResponsesWrapper,
	TestsWrapper,
	Text,
	UiWrapper,
	UserWrapper,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Header from 'layout/components/Header/Header';

import BackNextButton from 'components/BackNextButton/BackNextButton';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import RoundedProgressBar from 'components/ProgressBar/RoundedProgressBar/RoundedProgressBar';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import QuestionnaireBox from './components/QuestionnaireBox';
import * as S from './styles';

const testIdentifier = 'health';

export const Health = PickerHOC(
	{
		target: {
			sourceWrapper: TargetsWrapper,
			sourcePath: 'targets',
			arrayItemMatcher: {
				type: 'param',
				paramName: 'targetId',
				itemPropertyPath: 'id',
			},
		},
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
		test: {
			sourceWrapper: TestsWrapper,
			sourcePath: 'tests',
			arrayItemMatcher: {
				type: 'value',
				itemPropertyPath: 'identifier',
				value: testIdentifier,
			},
		},
	},
	LoadingScreen,
)(() => {
	const {
		saveResponse,
		getResponse,
		isTestSettled,
		registerTestCompletion,
	} = TestResponsesWrapper.use();
	const { useHeader, useLoading } = UiWrapper.use();
	const { navigateTo, goBack } = NavigationWrapper.use();
	const { updateUser } = UserWrapper.use();

	const [loading, setLoading] = useState();

	const [isB2B] = useState(localStorage.getItem('B2Flow') === 'B2B' ? true : false || false);

	const { target, user, test } = PickerHOC.use();

	useEffect(() => {
		console.log('📌 user', user);
		console.log('📌 target', target);
		console.log('📌 test', test);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// NAVIGATION
	const back = async () => {
		CONFIG.routing.health.back(goBack);
	};

	const next = async () => {
		try {
			await registerTestCompletion(testIdentifier);
			setLoading('Guardando...');
			await updateUser({
				...user,
				metadata: {
					...user?.metadata,
					healthOK: true,
				},
			});
			CONFIG.routing.health.next(navigateTo);
		} catch (e) {
			setLoading('Guardando...');
			await updateUser({
				...user,
				metadata: {
					...user?.metadata,
					healthOK: false,
				},
			});
			CONFIG.routing.health.ko(navigateTo);
		}
	};

	const { t, i18n } = useTranslation();

	useLoading(loading, { loadingMessage: loading });
	useHeader(<Header goBack={isMobile ? back : undefined} />, []);
	useInitialScrollToTop();

	return (
		<Wrapper width={'70%'}>
			<RoundedProgressBar
				step={3}
				total={6}
				styleWrapper={{ maxWidth: 450 }}
				label={isB2B ? 'Datos personales' : ''}
			/>
			<Text headingPrimarySt>{t('health.title')}</Text>
			{test.testQuestions?.map((tq) => [
				<QuestionnaireBox
					text={tq.metadata[`title${i18n.language.toUpperCase()}`]}
					listWithTooltips={true}
					tooltipText={tq.metadata?.[`tooltip${i18n.language.toUpperCase()}`]}
					onChange={(v) => saveResponse(tq.id, v)}
					value={getResponse(tq.id)}
				/>,
				<S.QuestionnaireBoxLine />,
			])}
			<BackNextButton
				onClickNext={next}
				onClickBack={back}
				nextText={t('buttons.next')}
				backText={t('buttons.back')}
				isBackShown={!isMobile}
				isNextDisabled={!isTestSettled(testIdentifier)}
				justifyContent={'evenly'}
			/>
		</Wrapper>
	);
});
